<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="personnePhysique?.civilite"
[label]="step1.getcivilite"
[type]="'select'"
[optionsWithCode]="optionsSelect"
[rule]="'required'"
[errorMessage]="{'required' : 'ctr_9'}"
[typeSelect]="optionsSelectType"
[name]="getUid()+'_SepAtt_civilite'">
</app-form-input>

<app-form-input *ngIf="formName !== 'DIVE_AT'"
[parentForm]="parentForm"
	[disabled]="disabled"
[value]="personnePhysique?.pren"
[label]="step1.getpren"
[type]="'text'"
[rule]="'required|minSize_1|maxSize_50'"
[errorMessage]="{'required' : 'ctr_9'}"
[name]="getUid()+'_SepAtt_pren'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
	[disabled]="disabled"
[value]="personnePhysique?.nom"
[label]="step1.getnom"
[type]="'text'"
[rule]="'required|minSize_5|maxSize_255'"
[errorMessage]="{'required' : 'ctr_9', 'minLength' : 'ctr_8'}"
[name]="getUid()+'_SepAtt_nom'">
</app-form-input>

<app-form-input *ngIf="formName === 'DIVE_AT'"
[parentForm]="parentForm"
	[disabled]="disabled"
[value]="personnePhysique?.pren"
[label]="step1.getpren"
[type]="'text'"
[rule]="'required|minSize_1|maxSize_50'"
[errorMessage]="{'required' : 'ctr_9'}"
[name]="getUid()+'_SepAtt_pren'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
	[disabled]="disabled"
[value]="personnePhysique?.fonc"
[label]="step1.getfonc"
[type]="'text'"
[rule]="'required|minSize_1|maxSize_100'"
[errorMessage]="{'required' : 'ctr_9'}"
[name]="getUid()+'_SepAtt_fonc'">
</app-form-input>
